var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"day-track",class:{
    editable: _vm.selectable,
    mobile: _vm.isMobile,
    'timeline-open': _vm.openTimelineOnClick,
  },on:{"mousedown":_vm.onMouseDown,"dblclick":_vm.onDblClick,"click":_vm.onClick,"drop":function($event){return _vm.$emit('drop', $event)},"dragover":function($event){return _vm.$emit('dragover', $event)}}},[_vm._l((_vm.days),function(day,i){return _c('div',{key:day.toMillis(),staticClass:"day-track__day lighten-1 prevent-select",class:[
      _vm.dayClass(day),
      _vm.selectedMobile(day),
      { 'timeline-hover': _vm.openTimelineOnClick } ],style:({
      left: (_vm.startIdx + i) * _vm.cell.w + 'px',
      height: _vm.cell.h + 'px',
      width: _vm.cell.w + 'px',
    })},[_vm._t("default",null,{"day":day})],2)}),(_vm.emptySlots > 0)?_c('div',{staticClass:"day-track__day__empty-slot",style:({
      left: _vm.days.length * _vm.cell.w + 'px',
      height: _vm.cell.h + 'px',
      width: _vm.cell.w * _vm.emptySlots + 'px',
    })}):_vm._e(),(_vm.isForReservations)?_c('div',{staticClass:"overlay"},[_vm._t("overlay")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }